// Curated, not exhaustive - covers Norway plus the countries tourists paying
// by card here actually come from, not all ~200 ITU dialing codes.
export const COUNTRY_CODES = [
  { code: '47', name: 'Norge', flag: '🇳🇴' },
  { code: '46', name: 'Sverige', flag: '🇸🇪' },
  { code: '45', name: 'Danmark', flag: '🇩🇰' },
  { code: '358', name: 'Finland', flag: '🇫🇮' },
  { code: '354', name: 'Island', flag: '🇮🇸' },
  { code: '49', name: 'Tyskland', flag: '🇩🇪' },
  { code: '44', name: 'Storbritannia', flag: '🇬🇧' },
  { code: '31', name: 'Nederland', flag: '🇳🇱' },
  { code: '32', name: 'Belgia', flag: '🇧🇪' },
  { code: '33', name: 'Frankrike', flag: '🇫🇷' },
  { code: '34', name: 'Spania', flag: '🇪🇸' },
  { code: '39', name: 'Italia', flag: '🇮🇹' },
  { code: '41', name: 'Sveits', flag: '🇨🇭' },
  { code: '43', name: 'Østerrike', flag: '🇦🇹' },
  { code: '48', name: 'Polen', flag: '🇵🇱' },
  { code: '351', name: 'Portugal', flag: '🇵🇹' },
  { code: '30', name: 'Hellas', flag: '🇬🇷' },
  { code: '353', name: 'Irland', flag: '🇮🇪' },
  { code: '420', name: 'Tsjekkia', flag: '🇨🇿' },
  { code: '372', name: 'Estland', flag: '🇪🇪' },
  { code: '371', name: 'Latvia', flag: '🇱🇻' },
  { code: '370', name: 'Litauen', flag: '🇱🇹' },
  { code: '7', name: 'Russland', flag: '🇷🇺' },
  { code: '380', name: 'Ukraina', flag: '🇺🇦' },
  { code: '1', name: 'USA/Canada', flag: '🇺🇸' },
  { code: '61', name: 'Australia', flag: '🇦🇺' },
  { code: '86', name: 'Kina', flag: '🇨🇳' },
  { code: '81', name: 'Japan', flag: '🇯🇵' },
  { code: '82', name: 'Sør-Korea', flag: '🇰🇷' },
  { code: '91', name: 'India', flag: '🇮🇳' },
  { code: '971', name: 'De forente arabiske emirater', flag: '🇦🇪' },
];
